// eslint-disable-next-line import/prefer-default-export
export const resolutions : Record<number | 'max', string> = {
  max: '1320x400',
  900: '900x400',
  600: '600x400',
}
